import { ConsentEventType } from 'src/Shared/EventPublisher/ConsentEventType';
import { Publish } from 'src/Shared/EventPublisher/EventEmitter';
import { IConfig } from './IConfig';
import { Configuration } from './SiteConfigs';

let ActiveProfile: Readonly<IConfig> = null;

let ActiveLanguageId: Readonly<string> = null;

const SetActiveProfile = (profileId: string): void => {
  if (ActiveProfile !== null) throw new Error();

  const configuration = new Configuration();

  const activeProfile = configuration
    .GetProfileConfigs()
    .filter((profileConfig) => profileConfig.ProfileId === profileId)[0];

  if (!activeProfile) throw new Error();

  ActiveProfile = Object.freeze(activeProfile);
  ActiveLanguageId = ActiveProfile.DefaultLanguage;
};

const SetActiveLanguage = (languageId: string): void => {
  if (!ActiveProfile.SupportedLanguages[languageId]) throw new Error(`language ${languageId} not supported`);
  ActiveLanguageId = languageId;
  Publish(ConsentEventType.LANGUAGE_SWITCHED);
};

export { ActiveProfile, ActiveLanguageId, SetActiveProfile, SetActiveLanguage };
